import { FC } from 'react';
import {
	Section1,
	Section2,
	Section3,
	Section4,
	Section5,
	Section7,
	Links,
	Images,
	Section6
} from './article3_model';
import '../ArticleComponent.scss';
import './Article3.scss';
import { ButtonComponent } from '../../../UI/ButtonComponent/ButtonComponent';
const Article3Component: FC = () => {
	const handleNavigate = () => {
		window.open(Links.beacon_discovery, '_blank', 'noopener');
	};

	return (
		<div className='page third'>
			<div className='section--intro'>
				<div className='section-container'>
					<div className='section-heading'>{Section1.heading}</div>
					<p className='info-600'>
						{' '}
						<span>Every year, </span>
						<a href={Links.expo_west} target='_blank' rel='noopener' className='info-600'>
							Natural Products Expo
						</a>
						<span>{Section1.content1}</span>
					</p>
					<p className='nospace-bottom'>
						<span className='info-400'>This year, I have a game-changer: </span>
						<a className='info-400' href={Links.beacon_discovery} target='_blank' rel='noopener'>
							Beacon Discovery
						</a>
						<span className='info-400'>
							. You may remember Beacon Discovery from Expo’s past or even from{' '}
						</span>
						<a className='info-400' href={Links.beacon_discovery} target='_blank' rel='noopener'>
							Newtopia Now
						</a>
						<span className='info-400'>{Section1.content2}</span>
					</p>

					<img src={Images.beaconHome} alt='Beacon Home' className='non-clickable'></img>
					<p>
						<span className='info-400'>As the </span>
						<span className='info-700'>
							official product discovery platform of Natural Products Expo,{' '}
						</span>
						<span className='info-400'>
							{' '}
							I’m using it to prepare for the event months in advance and to help stay focused
							amidst the excitement.
						</span>
					</p>

					<p className='nospace-bottom'>
						<span className='info-400'>{Section1.content4}</span>
						<a className='info-400' href={Links.newhope_standrad} target='_blank' rel='noopener'>
							New Hope Network Standards
						</a>
						.
					</p>
				</div>
			</div>

			<div className='section--image-right-wave first'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section2.heading}</h3>

					<div className='imageRightContentLeft nospace-top'>
						<div className='content'>
							<p className='info-400'>{Section2.smalltext}</p>

							<ul>
								<li>
									<span className='info-700'>{Section2.item1.content_bold}</span>
									<span className='info-400'>{Section2.item1.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.item2.content_bold}</span>
									<span className='info-400'>{Section2.item2.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.item3.content_bold}</span>
									<span className='info-400'>{Section2.item3.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.item4.content_bold}</span>
									<span className='info-400'>{Section2.item4.content}</span>
								</li>
							</ul>
						</div>
						<div className='image'>
							<img src={Images.sort} alt='Filters' className='non-clickable' />
						</div>
					</div>

					<span className='info-400'>Once I identified products that align with my search, </span>
					<span className='info-700'>Beacon Discovery’s detailed product page </span>

					<span className='info-400'>{Section2.content1}</span>
					<span className='info-700'>No more searching many different websites </span>
					<span className='info-400'>
						to find the information you need to make a buying decision.
					</span>
				</div>
			</div>

			<div className='section--image-left'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section3.heading}</h3>
					<p className='info-600'>{Section3.content1}</p>

					<div className='imageLeftContentRight nospace-top'>
						<div className='image'>
							<img src={Images.picks} alt='Filters' className='non-clickable' />
						</div>
						<div className='content'>
							<ul>
								<li>
									<span className='info-400'>{Section3.item1}</span>
								</li>
								<li>
									<span className='info-400'>{Section3.item2}</span>
								</li>
								<li>
									<span className='info-400'>{Section3.item3}</span>
								</li>
							</ul>
						</div>
					</div>
					<p className='nospace-bottom'>
						<span className='info-700'>Pro Tip: </span>{' '}
						<span className='info-400'>{Section3.content2}</span>
					</p>
				</div>
			</div>

			<div className='section--image-right'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section4.heading}</h3>
					<div className='imageRightContentLeft nospace-top nospace-bottom'>
						<div className='content'>
							<p>
								<span className='info-400'>
									Navigating the Expo floor can be a challenge – even for event veterans. This year,
									the
								</span>
								<span className='info-700'> Beacon Discovery integration </span>
								<span className='info-400'>{Section4.content1}</span>
							</p>

							<p>
								<span className='info-400'>Before the show, </span>
								<span className='info-700'>download the Expo West app. </span>
								<span className='info-400'>{Section4.content2}</span>
							</p>
							<p className='nospace-bottom'>
								<span className='info-400'>Most importantly, this helps me </span>
								<span className='info-700'>
									plan a route that minimizes backtracking and maximizes efficiency.
								</span>
								<span className='info-400'>
									{' '}
									This can be especially helpful to retailers during{' '}
								</span>
								<span className='info-700'>Buyers hours only </span>
								<span className='info-400'>
									on Thursday and Friday — navigating effortlessly to make the most of this time.
								</span>
							</p>
						</div>
						<div className='image'>
							<img src={Images.naturalprod_home} className='non-clickable'></img>
						</div>
					</div>
				</div>
			</div>

			<div className='section--image-right second'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section5.heading}</h3>
					<p className='info-400'>{Section5.content1}</p>
					<div className='imageRightContentLeft nospace-bottom'>
						<div className='content'>
							<ul>
								<li>
									<span className='info-400'>{Section5.item1.content}</span>
									<span className='info-700'>{Section5.item1.contentbold}</span>
								</li>

								<li>
									<span className='info-400'>{Section5.item2.content}</span>
									<span className='info-700'>{Section5.item2.contentbold}</span>
								</li>

								<li className='nospace-bottom'>
									<span className='info-400'>{Section5.item3.content1}</span>
									<span className='info-700'>{Section5.item3.contentbold}</span>
									<span className='info-400'>{Section5.item3.content2}</span>
								</li>
							</ul>
						</div>
						<div className='image'>
							<img src={Images.greet} className='non-clickable'></img>
						</div>
					</div>
				</div>
			</div>

			<div className='section--noimage third'>
				<div className='section-container nospace-bottom'>
					<h3 className='section-heading'>{Section6.heading}</h3>
					<ul>
						<li>
							<span className='info-700'>{Section6.item1.contentbold}</span>
							<span className='info-400'>{Section6.item1.content}</span>
						</li>
						<li>
							<span className='info-700'>{Section6.item2.contentbold}</span>
							<span className='info-400'>{Section6.item2.content}</span>
						</li>
						<li className='nospace-bottom'>
							<span className='info-700'>{Section6.item3.contentbold}</span>
							<span className='info-400'>{Section6.item3.content}</span>
						</li>
					</ul>
				</div>
			</div>

			<div className='section--noimage'>
				<div className='section-container nospace-bottom'>
					<h3 className='section-heading'>{Section7.heading}</h3>
					<p className='info-400'>{Section7.content}</p>
					<div className='button-container'>
						<ButtonComponent
							text={'START DISCOVERING NOW'}
							onClick={handleNavigate}
							style={'rounded-button primary addToCart'}
							icon={<i className='ri-arrow-right-s-line arrowIcon'></i>}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Article3Component;
